import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { PLAY_STORE_URL } from '../../../Shared/app-store-links';

@Component({
  selector: 'app-hero',
  imports: [CommonModule, RouterLink],
  templateUrl: './hero.html',
  styleUrl: './hero.css',
})
export class Hero {
  /** Public Play listing for the app buttons — single source of truth in app-store-links.ts. */
  readonly playStoreUrl = PLAY_STORE_URL;

  private readonly calendlyUrl =
    'https://calendly.com/tahir-aslam-techcolleagues/meeting-with-tahir-aslam-founder-tech-colleagues?month=2026-06';

  readonly companySizes = [
    'Micro company (1-5 employees)',
    'Small company (5-50 employees)',
    'Midsized company (50-250 employees)',
    'Large company (250+ employees)',
  ];

  showMeetingOptions = false;

  @ViewChild('meetingDropdown') meetingDropdown!: ElementRef<HTMLElement>;

  toggleMeetingOptions(): void {
    this.showMeetingOptions = !this.showMeetingOptions;
  }

  openMeetingLink(): void {
    window.open(this.calendlyUrl, '_blank', 'noopener,noreferrer');
    this.showMeetingOptions = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.showMeetingOptions && !this.meetingDropdown.nativeElement.contains(event.target as Node)) {
      this.showMeetingOptions = false;
    }
  }
}